import { useContext, useMemo } from 'react';
import { PluginContext } from 'ts-components/Plugins/context';
import { mergeConfig } from '@kizenapps/engine/util';
import { useBusinessPluginApps } from './useBusinessPluginApps';

export const useBusinessAppConfig = (pluginApiName: string) => {
  const { plugins } = useContext(PluginContext);

  const selectedPlugin = useMemo(() => {
    return plugins?.[pluginApiName];
  }, [plugins, pluginApiName]);

  const businessConfig = useMemo(() => {
    return selectedPlugin?.business_config || {};
  }, [selectedPlugin]);

  const cleanConfig = useMemo(() => {
    return businessConfig.__kizen_clean_config || {};
  }, [businessConfig]);

  const { data: businessPluginApps, isLoading } = useBusinessPluginApps();

  const businessPluginApp = useMemo(() => {
    return businessPluginApps?.find(
      (app: any) => app.plugin_app.api_name === pluginApiName
    );
  }, [businessPluginApps, pluginApiName]);

  const baseConfig = useMemo(() => {
    return businessPluginApp?.plugin_app?.base_config || {};
  }, [businessPluginApp]);

  const rawConfig = useMemo(() => {
    return businessConfig.__kizen_setup_assistant_values || {};
  }, [businessConfig]);

  const mergedConfig = useMemo(() => {
    return mergeConfig(
      cleanConfig,
      baseConfig.disabled_keys || [],
      rawConfig,
      baseConfig.setup_assistant?.fields
    );
  }, [cleanConfig, baseConfig, rawConfig]);

  return {
    config: mergedConfig,
    isLoading,
  };
};
